import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import ImpactSection from './components/ImpactSection';
import CharitiesSection from './components/CharitiesSection';
import OurFamilySection from './components/OurFamilySection';
import FoundationStorySection from './components/FoundationStorySection';
import MentorshipSection from './components/MentorshipSection';
import StoriesOfImpactSection from './components/StoriesOfImpactSection';
import AboutSection from './components/AboutSection';
import DonationSection from './components/DonationSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import GhostAssistant from './components/GhostAssistant';
import MentoringPage from './pages/MentoringPage';
import FinancialEducationPage from './pages/FinancialEducationPage';
import HousingPage from './pages/HousingPage';
import UpcomingInitiativesPage from './pages/UpcomingInitiativesPage';
import TravelClubPage from './pages/TravelClubPage';
import AdminDashboard from './pages/AdminDashboard';
import DonationThankYou from './pages/DonationThankYou';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsAndConditionsPage from './pages/TermsAndConditionsPage';
import SmsTermsPage from './pages/SmsTermsPage';

import PartnerMarquee from './components/PartnerMarquee';

const HomePage = () => {
  return (
    <>
      <Navigation />
      <main>
        <HeroSection />
        <MissionSection />
        <FoundationStorySection />
        <ImpactSection />
        <MentorshipSection />
        <StoriesOfImpactSection />
        <PartnerMarquee />
        <CharitiesSection />
        <OurFamilySection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
      <GhostAssistant />
    </>
  );
};

function App() {
  return (
    <div className="App" data-testid="app-container">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mentoring" element={
            <>
              <Navigation />
              <MentoringPage />
              <Footer />
              <GhostAssistant />
            </>
          } />
          <Route path="/financial-education" element={
            <>
              <Navigation />
              <FinancialEducationPage />
              <Footer />
              <GhostAssistant />
            </>
          } />
          <Route path="/housing" element={
            <>
              <Navigation />
              <HousingPage />
              <Footer />
              <GhostAssistant />
            </>
          } />
          <Route path="/upcoming-initiatives" element={
            <>
              <Navigation />
              <UpcomingInitiativesPage />
              <Footer />
              <GhostAssistant />
            </>
          } />
          <Route path="/travel-club" element={
            <>
              <Navigation />
              <TravelClubPage />
              <Footer />
              <GhostAssistant />
            </>
          } />
          <Route path="/admin" element={
            <>
              <Navigation />
              <AdminDashboard />
              <Footer />
            </>
          } />
          <Route path="/thank-you" element={
            <>
              <Navigation />
              <DonationThankYou />
              <Footer />
              <GhostAssistant />
            </>
          } />
          <Route path="/privacy-policy" element={
            <>
              <Navigation />
              <PrivacyPolicyPage />
              <Footer />
            </>
          } />
          <Route path="/terms-and-conditions" element={
            <>
              <Navigation />
              <TermsAndConditionsPage />
              <Footer />
            </>
          } />
          <Route path="/sms-terms" element={
            <>
              <Navigation />
              <SmsTermsPage />
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
